module.exports = __webpack_public_path__ + "img/moovmoney.88a2ea86.png";